<template>
    <a-tree
    :treeData="treeData"
    showIcon
    autoExpandParent
    @select = 'onSelect'
    class="tree"
  >
    <template slot="custom" slot-scope="{pos}">
      <div v-if="(pos.split('-').length)==2" class="en_electricity_first_level"></div>
      <div v-else-if="(pos.split('-').length)==3" class="en_electricity_second_level"></div>
      <div v-else-if="(pos.split('-').length)==4" class="en_electricity_third_level"></div>
    </template>
  </a-tree>
</template>

<script>
import treeData from '../data.json';
export default{
  data(){
    return {
      treeData:[],
    }
  },
  props:{},
  watch:{},
  created(){
    this.getList();
  },
  computed:{},
  methods:{
    onSelect (selectedKeys, info) {
      let {selected} = info;
      if(!selected) info.selected = true;
      let flag = info.node.dataRef.children;
      (!flag)&& this.$emit('selected',selectedKeys);
    },
    loadData(){
      this.treeData = treeData.data;
    },
    getList(){
      this.loadData();
    }
  }
}
</script>

<style lang='less' scoped>
.tree{
  /deep/li{
    padding:0px;
  }
  /deep/li .ant-tree-node-content-wrapper{
    display: block;
    height:36px;
    line-height: 36px;
  }
  /deep/li span.ant-tree-switcher{
    float: right;
  }
  /deep/li span.ant-tree-switcher, /deep/li span.ant-tree-iconEle{
    width:36px;
    height: 36px;
    line-height: 36px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/unusualEnterpriseAmount/components/leftMenu.vue